 <!-- JavaScript to handle hover effect, redirection, and adding variant-selected class dynamically -->
        document.addEventListener('DOMContentLoaded', function() {
          var variantNameElement = document.getElementById('current-variant-name');
          var originalVariantName = variantNameElement.textContent;

          // Ensure the correct variant name is shown on page load
          var selectedRadio = document.querySelector('input[name="color-variant-option"]:checked');
          if (selectedRadio) {
            document.querySelector('label[for="' + selectedRadio.id + '"]').classList.add('variant-selected');
            variantNameElement.textContent = selectedRadio.getAttribute('data-name');
            originalVariantName = selectedRadio.getAttribute('data-name');
          }

          // Loop through all labels for hover and click events
          document.querySelectorAll('label[for^="color-variant-opt-"]').forEach(function(label) {

            // Hover effect to show variant name
            label.addEventListener('mouseenter', function() {
              variantNameElement.textContent = this.getAttribute('data-name');
            });

            // Restore the original name when mouse leaves (unless it is selected)
            label.addEventListener('mouseleave', function() {
              var selectedRadio = document.querySelector('input[name="color-variant-option"]:checked');
              if (selectedRadio) {
                variantNameElement.textContent = selectedRadio.getAttribute('data-name');
              } else {
                variantNameElement.textContent = originalVariantName;
              }
            });

            // Change event to handle selection and redirection
            label.addEventListener('click', function() {
              var radio = document.getElementById(label.getAttribute('for'));

              // Update the selected variant name
              originalVariantName = radio.getAttribute('data-name');
              variantNameElement.textContent = originalVariantName;

              // Remove the 'variant-selected' class from all labels
              document.querySelectorAll('.opt-label').forEach(function(lbl) {
                lbl.classList.remove('variant-selected');
              });

              // Add the 'variant-selected' class to the current label
              label.classList.add('variant-selected');

              // Redirect to the URL after selection
              window.location.href = radio.getAttribute('data-url');
            });
          });
        });


document.addEventListener('DOMContentLoaded', function() {
  const variantList = document.querySelector('.variant-list');
  const scrollbarHandle = document.querySelector('.os-scrollbar-handle');
  const scrollbarTrack = document.querySelector('.os-scrollbar-track');

  let isDraggingHandle = false;
  let startX = 0;
  let handleStartLeft = 0;

  function updateScrollbar() {
    const totalScrollWidth = variantList.scrollWidth;
    const visibleWidth = variantList.clientWidth;
    const trackWidth = scrollbarTrack.clientWidth;

    if (totalScrollWidth > visibleWidth) {
      // Calculate the ratio of visible content to total content
      const handleWidthRatio = visibleWidth / totalScrollWidth;
      // Set the handle width dynamically based on the content overflow
      const handleWidth = Math.max(trackWidth * handleWidthRatio, 30); // Minimum width of 30px
      scrollbarHandle.style.width = handleWidth + 'px';

      // Ensure the scrollbar is visible
      scrollbarTrack.style.opacity = '1';
      scrollbarTrack.style.pointerEvents = 'auto';
    } else {
      // Hide the scrollbar if there's no need for scrolling
      scrollbarTrack.style.opacity = '0';
      scrollbarTrack.style.pointerEvents = 'none';
    }
  }

  // Move the checked radio button to the first position
  function moveCheckedVariantFirst() {
    const checkedInput = variantList.querySelector('input[type="radio"]:checked');
    if (checkedInput) {
      const optionSelectorBtns = checkedInput.closest('.option-selector__btns');
      const checkedLabel = checkedInput.nextElementSibling;

      if (optionSelectorBtns && checkedLabel) {
        optionSelectorBtns.insertBefore(checkedInput, optionSelectorBtns.firstChild);
        optionSelectorBtns.insertBefore(checkedLabel, checkedInput.nextSibling);
      }
    }
  }

  if (variantList && scrollbarHandle && scrollbarTrack) {
    // Sync the movement of the custom scrollbar handle with variant-list scrolling
    variantList.addEventListener('scroll', function() {
      if (!isDraggingHandle) {
        const totalScrollWidth = variantList.scrollWidth - variantList.clientWidth;
        const scrollRatio = variantList.scrollLeft / totalScrollWidth;

        const handleWidth = scrollbarHandle.clientWidth;
        const trackWidth = scrollbarTrack.clientWidth;
        const maxHandleLeft = trackWidth - handleWidth;
        const handleLeft = maxHandleLeft * scrollRatio;

        // Move the handle based on scroll position
        scrollbarHandle.style.transform = `translateX(${handleLeft}px)`;
      }
    });

    // Handle drag functionality for the scrollbar handle
    function handleDragStart(e) {
      isDraggingHandle = true;
      startX = e.pageX || e.touches[0].pageX; // Handle both mouse and touch events
      handleStartLeft = scrollbarHandle.getBoundingClientRect().left - scrollbarTrack.getBoundingClientRect().left;

      document.body.classList.add('scrolling-active');
      e.preventDefault(); // Prevent text selection while dragging
    }

    function handleDragMove(e) {
      if (isDraggingHandle) {
        const trackWidth = scrollbarTrack.clientWidth;
        const handleWidth = scrollbarHandle.clientWidth;
        const maxHandleLeft = trackWidth - handleWidth;

        // Calculate new position based on mouse or touch movement
        let x = handleStartLeft + ((e.pageX || e.touches[0].pageX) - startX);

        // Clamp x between 0 and the maximum value
        x = Math.max(0, Math.min(x, maxHandleLeft));

        const scrollRatio = x / maxHandleLeft;
        const totalScrollWidth = variantList.scrollWidth - variantList.clientWidth;

        // Move the handle and scroll the variant list
        scrollbarHandle.style.transform = `translateX(${x}px)`;
        variantList.scrollLeft = scrollRatio * totalScrollWidth;
      }
    }

    function handleDragEnd() {
      isDraggingHandle = false;
      document.body.classList.remove('scrolling-active');
    }

    // Add mouse and touch event listeners for drag functionality
    scrollbarHandle.addEventListener('mousedown', handleDragStart);
    document.addEventListener('mousemove', handleDragMove);
    document.addEventListener('mouseup', handleDragEnd);

    scrollbarHandle.addEventListener('touchstart', handleDragStart);
    document.addEventListener('touchmove', handleDragMove);
    document.addEventListener('touchend', handleDragEnd);

    // Update scrollbar visibility and handle size when the window resizes
    window.addEventListener('resize', updateScrollbar);

    // Initially set the scrollbar visibility and handle size
    updateScrollbar();

    // Move the checked variant to the first position after DOM content has loaded
    moveCheckedVariantFirst();
  }
});
